import Pricing7 from './Pricing7'
export default Pricing7
